import styled from 'styled-components';

const Form = styled.form`
  button[type='submit'] {
    width: 100px;
    font-weight: bold;
    font-size: 1.6rem;
    cursor: pointer;
    border-radius: 0.5rem;
    border: 0;
  }
`;

export default Form;